import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from '@fortawesome/pro-duotone-svg-icons/faComment'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'

const ChatToggleButton = ({ isOpen, unreadCount, onClick }) => (
    <div className="chat-toggle" onClick={onClick}>
        <FontAwesomeIcon
            icon={isOpen ? faTimes : faComment}
            size="lg"
            className="icon"
        />
        {!isOpen && unreadCount > 0 && (
            <span className="chat-badge">
                {unreadCount > 99 ? '99+' : unreadCount}
            </span>
        )}
    </div>
)

export default ChatToggleButton
